import { useTranslation } from "react-i18next";
import { Gift } from "lucide-react";

const MILESTONES = [
    { at: 3, credits: 5 },
    { at: 7, credits: 5 },
];

export default function OnboardingGenerationProgress({ count }) {
    const { t } = useTranslation();

    if (!count || count <= 0 || count >= 10) return null;

    const remaining = 10 - count;
    let messageKey = "generationProgress.early";
    if (count >= 4 && count <= 6) messageKey = "generationProgress.halfway";
    if (count >= 7) messageKey = "generationProgress.almost";

    return (
        <div className="mb-4 p-4 bg-indigo-50 rounded-lg border border-indigo-200">
            <div className="flex items-center justify-between text-sm mb-2">
                <span className="font-medium text-indigo-900">
                    {t(messageKey, { count, remaining })}
                </span>
                <span className="text-indigo-600 font-bold">{count}/10</span>
            </div>
            <div className="w-full bg-indigo-200 rounded-full h-2 mb-3">
                <div
                    className="bg-indigo-600 h-2 rounded-full transition-all"
                    style={{ width: `${(count / 10) * 100}%` }}
                />
            </div>
            <div className="flex gap-2 flex-wrap">
                {MILESTONES.map((m) => (
                    <span
                        key={m.at}
                        className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full ${
                            count >= m.at
                                ? "bg-green-100 text-green-700"
                                : "bg-indigo-100 text-indigo-600"
                        }`}
                    >
                        <Gift className="w-3 h-3" />
                        {count >= m.at ? "✓" : ""} +{m.credits} @ {m.at}
                    </span>
                ))}
                <span className={`inline-flex items-center text-xs px-2 py-0.5 rounded-full ${
                    count >= 10 ? "bg-green-100 text-green-700" : "bg-indigo-100 text-indigo-600"
                }`}>
                    🎯 {t("generationProgress.goal")} @ 10
                </span>
            </div>
        </div>
    );
}
